<template>
  <section
    v-observe-visibility="canYouSeeMee"
    class="padding_large vimeo-carousel"
    :class="{ 'bg-gray': data.gray_background }"
  >
    <ModuleContainer>
      <ModuleHeading :level="2">{{ data.module_title }}</ModuleHeading>
      <div
        class="module-description"
        v-if="data.module_description"
        v-html="data.module_description"
      ></div>
      <OwlCarousel
        v-observe-visibility="canYouSeeMee"
        class="carousel-videos"
        :options="options"
        v-if="data.videos && data.videos.length"
      >
        <div
          v-observe-visibility="itemVisibility"
          class="items"
          v-for="(video, k) in data.videos"
          :key="k"
        >
          <div class="embed-hold" @click="playVideo(k)">
            <div :ref="'placehold_' + k" class="video-placehold" />
            <div class="embed" :ref="'video_' + k" v-html="video.vimeo_video" />
          </div>
          <h4 class="video-title">{{ video.title }}</h4>
          <div class="video-description">{{ video.description }}</div>
        </div>
      </OwlCarousel>
    </ModuleContainer>
  </section>
</template>

<script>
import Player from "@vimeo/player";

import OwlCarousel from "@/components/elements/OwlCarousel";

export default {
  components: {
    OwlCarousel
  },
  props: ["data"],
  data() {
    return {
      players: {}
    };
  },
  computed: {
    options() {
      const VM = this;
      return {
        loop: false,
        center: false,
        nav: true,
        autoplay: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        freeDrag: false,
        callbacks: true,
        navText: [VM.svgIcons.arrow2, VM.svgIcons.arrow2],
        responsive: {
          0: {
            items: 1,
            margin: 0
          },
          767: {
            items: 2,
            margin: 15
          },
          1024: {
            items: 3,
            margin: 25
          }
        }
      };
    }
  },
  mounted() {},
  destroyed() {
    const VM = this;
    const size = Object.keys(VM.players).length;
    if (size) {
      Object.keys(VM.players).forEach(key => {
        VM.players[key].destroy();
      });
    }
  },
  methods: {
    canYouSeeMee(isMe) {
      if (!isMe) {
        this.pauseAllPlaying();
      }
    },
    itemVisibility(vis) {
      this.pauseAllPlaying();
    },
    pauseAllPlaying(except = "") {
      const VM = this;
      const size = Object.keys(VM.players).length;
      if (size) {
        Object.keys(VM.players).forEach(key => {
          if (key !== except) VM.players[key].pause();
        });
      }
    },
    playVideo(id) {
      const placeholdID = "placehold_" + id;

      const player_ID = "video_" + id;
      const VM = this;
      let player = VM.players[player_ID];
      if (!player) {
        const el = VM.$refs[player_ID];
        VM.$refs[placeholdID][0].classList.add("is-activated");
        if (!el[0]) return;
        const iframe = el[0].querySelector("iframe");
        player = new Player(iframe);
        VM.players[player_ID] = player;
      }
      const size = Object.keys(VM.players).length;
      if (size) {
        VM.players[player_ID].on("play", () => {
          VM.pauseAllPlaying(player_ID);
        });

        VM.players[player_ID].play();
      }
      player.play();
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/vars.scss";
.vimeo-carousel {
  .module-description {
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 35px;
    max-width: 650px;
    @include mquery(767px) {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  .carousel-videos {
    position: relative;
    .owl-next,
    .owl-prev {
      position: absolute;
      top: 105px;
      right: -30px;
      @include mquery(767px) {
        right: 5px;
        top: 30%;
        background: #fff !important;
        display: flex;
        justify-content: center;
        border-radius: 30px;
        height: 30px;
        width: 30px;
      }
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
      &:hover {
        svg g {
          fill: #2a2e34;
        }
      }
      @include mquery(767px) {
        margin: 5px;
      }
      svg {
        height: 22px;
        width: 22px;
        g {
          fill: $purple;
        }
        @include mquery(767px) {
          width: 12px;
        }
      }
    }

    .owl-prev {
      left: -30px;
      right: auto;
      @include mquery(767px) {
        left: 5px;
        right: auto;
      }
      svg {
        transform: rotate(180deg);
        @include mquery(767px) {
          position: relative;
          left: -1px;
        }
      }
    }
    .owl-next {
      @include mquery(767px) {
        svg {
          left: 2px;
          position: relative;
        }
      }
    }
    .owl-dots {
      display: none;
    }
    .video-title {
      margin-top: 15px;
      font-size: 20px;
      margin-bottom: 5px;
      @include mquery(767px) {
        font-size: 18px;
        margin-top: 10px;
      }
      @include mquery(460px) {
        font-size: 16px;
      }
    }
    .video-description {
      font-weight: 300;
      font-size: 14px;
    }
    .embed-hold {
      position: relative;
      .video-placehold {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        background: transparent;
        &.is-activated {
          display: none;
        }
      }
    }
    .embed {
      position: relative;
      padding-bottom: 62.53%;
      height: 0;
      background-color: #d8d8d8;

      iframe {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}
</style>
